import { render } from "./PolicyPage.vue?vue&type=template&id=5fc92542&scoped=true"
import script from "./PolicyPage.vue?vue&type=script&lang=js"
export * from "./PolicyPage.vue?vue&type=script&lang=js"

import "./PolicyPage.vue?vue&type=style&index=0&id=5fc92542&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc92542"]])

export default __exports__